<template lang="html">
  <div class="main-container">
    <div>
      <breadcrumb main_step_name="Global Settings" sub_step_name="Utilities" step_name="Professional Tax" @goToSubStep="substep"
        @goToMainStep="mainstep" />

      <div class="margin-top-31">
        <tl-header type="h1">
          <div class="main-header">Professional Tax</div>
        </tl-header>
      </div>

      <div class="margin-top-26">
        <tl-search/>
      </div>
      <div class="margin-top-09">
        <label class="note-Professional ">Note: Professional tax is not applicable in Haryana, Delhi, U.P</label>
      </div>

      <div v-if="!(isAddPT || isEditPT)">

        <div class="margin-top-29 width-56">
          <div>
            <!-- <data-table :columns="tableColumns" :tableData="tableData" :showinrow="showinrow" :showedit="showedit">
              <template v-slot:rowcontent="slotprops">

                <label v-if="slotprops.value.column.key=='status'" v-bind:class="{'completed-status':slotprops.value.record.completed, 'incompleted-status':!(slotprops.value.record.completed) }">
                  {{slotprops.value.record.completed ? 'Completed':'Incomplete'}}
                </label>
                <label class="flex-style" v-if="slotprops.value.column.key=='name'">
                  {{slotprops.value.record.name}}
                </label>
                <button v-if="slotprops.value.column.key=='action' && slotprops.value.record.completed" v-on:click="add(slotprops.value.record)">
                  <img src="@/assets/group-5.svg" class="Group-5" />
                </button>
                <button  v-if="slotprops.value.column.key=='action' && !(slotprops.value.record.completed)" v-on:click="edit(slotprops.value.record)">
                  <img src="@/assets/edit.svg" class="Group-5" />
                </button>
              </template>
            </data-table> -->
          </div>
          <!-- <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody class="labels" >
              <tr>
                <td @click="toggle($event,item)">
                  <label for="name">{{item.name}}</label>
                </td>
                <td>
                  <label for="status">{{item.completed ? 'Completed':'Incomplete'}}</label>
                </td>
                <span v-if="item.cities.length">

                  </span>
              </tr>
            </tbody>
          </table> -->


          <ul>
            <div class=" row table-header">
              <div class="col-6 padding-left-30">Name</div>
              <div class="col-6">Status</div>
            </div>

            <li v-for="(item, index) in tableData" :key="index">
              <div v-bind:class="{'height-50':!(item.isExpanded)}" class="table-row row">
                <div class="col-6 name-text" v-bind:class="{'cursor':item.cities.length, 'up':(item.isExpanded && item.cities.length), 'down':(!item.isExpanded && item.cities.length),}"
                  @click="toggle($event,item)">{{item.name}}</div>
                <div class="col-6" v-bind:class="{'status-text-completed':item.completed, 'status-text-incomplete':!(item.completed) }">
                  {{item.completed ? 'Completed':'Incomplete'}}
                  <span>
                    <button class="update-icon" v-if="item.completed" v-on:click="add(item)">
                      <img src="@/assets/group-5.svg" class="Group-5 add-btn" />
                    </button>
                    <button class="update-icon" v-if="!(item.completed)" v-on:click="edit(item)">
                      <img src="@/assets/edit.svg" class="Group-5" />
                    </button>
                  </span>
                </div>
                <div class="col-12 padding-right-0">
                  <span v-if="item.cities.length && item.isExpanded">
                    <li style="display:flex" v-for="(city, cityIndex) in item.cities" :key="cityIndex">
                      <div class="col-6 name-text">{{city.name}}</div>
                      <div class="col-6" v-bind:class="{'child-status-text-completed':city.completed, 'child-status-text-incomplete':!(city.completed) }">
                        {{city.completed ? 'Completed':'Incomplete'}}
                        <span class="">
                          <button class="child-update-icon" v-if="city.completed" v-on:click="add(city)">
                            <img src="@/assets/group-5.svg" class="Group-5 add-btn" />
                          </button>
                          <button class="child-update-icon" v-if="!(city.completed)" v-on:click="edit(city)">
                            <img src="@/assets/edit.svg" class="Group-5" />
                          </button>
                        </span>
                      </div>
                    </li>
                  </span>
                </div>



              </div>

            </li>
          </ul>

        </div>

        <div class="btn-group">
          <bottom-action-container>
            <btn-grp slot="end">
              <btn text="Back" type="secondary" @click="back" />
            </btn-grp>
          </bottom-action-container>
        </div>

      </div>


      <div v-if="isAddPT || isEditPT">

        <div class="margin-top-28">
          <label class="pt-Slabs">PT Slabs for Andhra Pradesh</label>
        </div>

        <div class="margin-top-21">
          <div class="filters">
            <txt label="Salary From" name="salaryFrom" v-model="formData.salaryFrom" placeholder />
            <txt label="Salary To" name="salaryTo" v-model="formData.salaryTo" placeholder />
            <txt label="Tax" name="tax" v-model="formData.tax" placeholder />
          </div>
        </div>

        <div class="margin-top-21">
          <a class="add-Slab" @click="addSlab"> Add Slab</a>
        </div>

        <btn-grp class="margin-top-48">
          <btn class="rectangle-btn" text="Cancel" type="secondary" v-on:click="cancel"></btn>
          <btn class="rectangle-btn" text="Save" type="primary" v-on:click="save"></btn>
        </btn-grp>

      </div>

      <pop-up-message v-if="showSuccessMsg" :message="`Professional Tax for ${stateName} has been saved.`" btnText="Back To Settings"
        @back="backToSettings"></pop-up-message>

    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions } from "vuex";

  export default {
    name: "loanCalculation",
    computed: {
      ...mapState({}),
      ...mapGetters({
        orgid: "onboard/organization/orgid"
      })
    },
    data() {
      return {
        showinrow: false,
        showedit: false,
        isAddPT: false,
        isEditPT: false,
        showSuccessMsg: false,
        stateName: "Andhra Pradesh",
        formData: {},
        tableColumns: [
          {
            label: "Name",
            key: "name"
          },
          {
            label: "Status",
            key: "status"
          },
          {
            label: "",
            key: "action"
          }
        ],
        tableData: [
          {
            id: 1,
            name: "Arunachal Pradesh",
            status: "Completed",
            action: "",
            completed: true,
            cities: [],
            isExpanded: false
          },
          {
            id: 2,
            name: "Andhra Pradesh",
            status: "Incomplete",
            action: "",
            completed: false,
            cities: [],
            isExpanded: false
          },
          {
            id: 3,
            name: "Assam",
            status: "Incomplete",
            action: "",
            completed: false,
            cities: [
              {
                name: "Guwahati",
                id: 11,
                status: "Incomplete",
                completed: false
              },
              { name: "Jorhat", id: 11, status: "Completed", completed: true },
              { name: "Silchar", id: 11, status: "Incomplete", completed: false }
            ],
            isExpanded: false
          },
          {
            id: 4,
            name: "Bihar",
            status: "Completed",
            action: "",
            completed: true,
            cities: [],
            isExpanded: false
          }
        ]
      };
    },
    mounted() { },

    methods: {
      ...mapActions({}),

      substep(val) {
        //console.log("sub step name", val);
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/settings/utilities`
        });
      },

      mainstep(val) {
        //console.log("main step name", val);
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/settings`
        });
      },

      toggle(event, item) {
        setTimeout(() => {
          item.isExpanded = !item.isExpanded;
        }, 100);
        //console.log("item:", item);
      },

      addSlab() { },

      add(record) {
        this.isAddPT = true;
      },

      edit(record) {
        this.isEditPT = true;
      },

      back() {
        this.$router.push({
          path: `/dashboard/${this.$route.params.entity_index}/settings/utilities`
        });
      },

      backToSettings() {
        this.showSuccessMsg = false;
        this.isAddPT = false;
        this.isEditPT = false;
      },

      cancel() {
        this.isAddPT = false;
        this.isEditPT = false;
      },

      save() {
        this.showSuccessMsg = true;
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "@/scss/_variables.scss";
  .note-Professional {
    font-family: Montserrat;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #b3b3b3;
  }

  .pt-Slabs {
    font-family: Montserrat;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #555555;
  }

  .flex-style {
    display: flex;
  }

  .add-Slab {
    height: 18px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #5d409f;
    cursor: pointer;
    margin-left: 4px;
  }

  .header.header1 {
    padding-bottom: 0px;
  }

  .margin-top-31 {
    margin-top: 3.1%;
  }

  .margin-top-26 {
    margin-top: 2.6%;
  }

  .margin-top-09 {
    margin-top: 0.9%;
  }

  .margin-top-09 {
    margin-top: 0.9%;
  }

  .margin-top-28 {
    margin-top: 2.8%;
  }

  .margin-top-29 {
    margin-top: 2.9%;
  }

  .margin-top-21 {
    margin-top: 2.1%;
  }

  .margin-top-48 {
    margin-top: 4.8%;
  }

  .margin-left-09 {
    margin-left: 0.9%;
  }

  .rectangle-btn {
    min-width: 100px;
    min-height: 35px;
    border-radius: 4px;
    padding: 0px;
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
  }

  .completed-status {
    height: 18px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #6ac259;
  }

  .incompleted-status {
    height: 18px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #f53b43;
  }

  .datatable-outer-container table.datatable {
    width: 56.6% !important;
  }

  .width-56 {
    width: 56.6%;
  }

  .search-container {
    width: 29.7%;
  }

  .main-container {
    padding: 1%;
  }

  .action-row {
    padding: 10px;
    width: 40px;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  table {
    width: 750px;
    border-collapse: collapse;
    margin: 50px auto;
  }

  th {
    background: #3498db;
    color: white;
    font-weight: bold;
  }

  td,
  th {
    padding: 10px;
    border: 1px solid #ccc;
    text-align: left;
    font-size: 18px;
  }

  .labels tr td {
    background-color: #2cc16a;
    font-weight: bold;
    color: #fff;
  }

  .label tr td label {
    display: block;
  }

  .height-50 {
    height: 50px;
  }

  .table-row {
    display: flex;
    margin-left: 0px;
  }

  .margin-top-10 {
    margin-top: 10px;
  }

  .table-header {
    height: 40px;
    background-color: #efefef;
    margin-left: 0px;
    padding-top: 10px;
    display: flex;
  }

  .up-arrow {
    content: " \2191";
  }

  .name-text {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 30px;
  }

  .up::after {
    // content: '\25B2';
    content: '\25BE';
    position: absolute;
    right: 90.5%;
    color: #6ac259;
    transform: rotate(180deg);
    font-size: 18px;
    margin-top: -3px;

  }

  .down::after {
    // content: '\25BC';
    content: '\25BE';
    position: absolute;
    right: 90.5%;
    color: #6ac259;
    font-size: 18px;
    margin-top: -3px;
  }


  .cursor {
    cursor: pointer;
  }

  .status-text-completed {
    padding-top: 15px;
    padding-bottom: 15px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #6ac259;
  }

  .child-status-text-completed {
    padding-top: 15px;
    padding-bottom: 15px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #6ac259;
    padding-left: 8px;
  }

  .status-text-incomplete {
    padding-top: 15px;
    padding-bottom: 15px;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #f53b43;
  }

  .child-status-text-incomplete {
      padding-top: 15px;
      padding-bottom: 15px;
      font-family: Montserrat;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #f53b43;
      padding-left: 8px;


    }

  .update-icon {
    top: 0px;
    position: relative;
    float: right;
    margin-right: 20px;
  }

  .child-update-icon {
    top: 0px;
    position: relative;
    float: right;
    margin-right: 20px;
  }

  li:nth-child(odd) {
    background: #f7f7f7;
  }

  li:nth-child(even) {
    background: #fff;
  }

  .padding-right-0 {
    padding-right: 0px;
  }

  .arrow {
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid $color-secondary;
    margin-right: 15px;
    &.up {
      transform: rotate(270deg);
    }
    &.down {
      transform: rotate(90deg);
    }
  }

  .triangle_down {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid $color-secondary;
    font-size: 0;
    line-height: 0;
    float: left;
    margin: 18px;

    &.up {
      transform: rotate(180deg);
    }

  }

  .add-btn {
    position: absolute;
    right: -5px;
  }

  .padding-left-30{
      padding-left: 30px
  }
</style>
